import { Component } from '@angular/core';
import { NavController, NavParams ,ToastController , ModalController} from 'ionic-angular';
import { Api } from '../../providers/api';
import { SearchCustomersPage } from '../search-customers/search-customers';
import { FormBuilder, Validators } from '@angular/forms';
import { Headers , RequestOptions } from '@angular/http';
import {CartManager} from "../../providers/cart-manager";
import {SelectionSearchPage} from '../selection-search/selection-search';
import { SelectionSearchService } from '../../services/selection-search' ;
import {GVLogger} from '../../services/gv-logger';
import  {LoginPage} from '../login/login';
import { MsgManager } from '../../providers/msg-manager';

@Component({
  selector: 'page-create-customer',
  templateUrl: 'create-customer.html'
})
export class CreateCustomerPage {





  formStatus:boolean;

  customerCreateForm:any ;

  countriesList: any;

  stateList1: any;
  cityList1: any;

  stateList2: any;
  cityList2: any;

  address1Country:any;
  address1State:any;
  address1City:any = "";

  address2Country:string = "na";
  address2State:string = "na";
  address2City:string = "";

  taxGroupList:any;
  customerGroupList:any;
  paymentTermsList:any;
  currenciesList:any;

  intelliRepUsersList:any;
  intelliRepUser:string = "";

  taxGroup:string = "";
  customerGroup:string = "";
  paymentTerms:string = "";
  paymentCurr:string = "";


  states1SelectControl:boolean = false;
  cities1SelectControl:boolean = false;

  states2SelectControl:boolean = false;
  cities2SelectControl:boolean = false;

  ERROR_TEXT = "error";

  userNameError = "";

  nameError="";
  taxGroupError="";
  customerGroupError = "";

  cityError= " ";
  emailError = false;
  countryCodes = [];
  mask
  provinces = []
  provinces2 = []
  shippingServices = [];

  constructor(public cartManager:CartManager ,public navCtrl: NavController, public navParams: NavParams, public api:Api,
  	public toastController:ToastController, public formBuilder: FormBuilder, public modalController:ModalController,
    public ss:SelectionSearchService,
    private gVLogger:GVLogger,
    private msgManager:MsgManager) {


    this.getCountries()
    this.getShippingServices()
    this.getProvincesWhileEditing(this.ss.getCountry1())
    this.setMask();


    this.ss.initializeService();
    this.getAllIntelliRepUsers();

    this.address1Country = this.ss.getCountry1();

    this.formStatus = false;
    this.loadPaymentTerms();
    this.getCurrenciesList();
    this.loadTaxGroups();
    this.loadCustomerGroups();
  	this.customerCreateForm = this.formBuilder.group({
		company: this.paymentTerms,
		paymentCurrency: this.paymentTerms,
    iUser:this.intelliRepUser,
		// prefix: ["",Validators.compose([Validators.maxLength(30), Validators.pattern('[a-zA-Z ]*'), Validators.required])],
		// name: ["",Validators.compose([Validators.maxLength(30), Validators.pattern('[a-zA-Z ]*'), Validators.required])],
    // email: ["",Validators.compose([Validators.maxLength(30), Validators.pattern('[a-zA-Z ]*'), Validators.required])],
    // password: ["",Validators.compose([Validators.maxLength(30), Validators.pattern('[a-zA-Z ]*'), Validators.required])],
    // userName: ["",Validators.compose([Validators.maxLength(30), Validators.pattern('[a-zA-Z ]*'), Validators.required])],
		// phone: ["",Validators.compose([Validators.maxLength(30), Validators.pattern('[a-zA-Z ]*'), Validators.required])],
    // taxGroup: this.taxGroup,
    // customerGroup: this.customerGroup,
		// isPrimary: [false],
		// address1name:["",Validators.compose([Validators.maxLength(30), Validators.pattern('[a-zA-Z ]*'), Validators.required])],
		// address1street:["",Validators.compose([Validators.maxLength(30), Validators.pattern('[a-zA-Z ]*'), Validators.required])],
		// address1city:this.address1City,
		// address1state:["",Validators.compose([Validators.maxLength(30), Validators.pattern('[a-zA-Z ]*'), Validators.required])],
		// address1zip:["",Validators.compose([Validators.maxLength(30), Validators.pattern('[a-zA-Z ]*'), Validators.required])],
		// address1country:this.address1Country,
	  // isSameAsAbove: [false],
		// address2name:["",Validators.compose([Validators.maxLength(30), Validators.pattern('[a-zA-Z ]*')])],
		// address2street:["",Validators.compose([Validators.maxLength(30), Validators.pattern('[a-zA-Z ]*')])],
		// address2city:this.address2City,
		// address2state:["",Validators.compose([Validators.maxLength(30), Validators.pattern('[a-zA-Z ]*'), Validators.required])],
		// address2zip:["",Validators.compose([Validators.maxLength(30), Validators.pattern('[a-zA-Z ]*')])],
		// address2country:this.address2Country



      prefix: ["",Validators.compose([Validators.maxLength(30)])],
      name: ["",Validators.compose([Validators.maxLength(30)])],
      contactPerson: ["",Validators.compose([Validators.maxLength(30)])],
      email: ["",Validators.compose([Validators.maxLength(30)])],
      accountId: ["",Validators.compose([Validators.maxLength(30)])],
      password: ["",Validators.compose([Validators.maxLength(30)])],
      userName: ["",Validators.compose([Validators.maxLength(30)])],
      phoneCode: ["",Validators.compose([Validators.maxLength(30)])],
      phoneNumber: ["",Validators.compose([Validators.maxLength(30)])],
      taxGroup: this.taxGroup,
      customerGroup: this.customerGroup,
      isPrimary: [false],
      address1name:["",Validators.compose([Validators.maxLength(30)])],
      billToPhone:["",Validators.compose([Validators.maxLength(30)])],
      billToEmail:["",Validators.compose([Validators.maxLength(30)])],
      address1street:["",Validators.compose([Validators.maxLength(30)])],
      address1city:this.address1City,
      address1state:["",Validators.compose([Validators.maxLength(30)])],
      shippingService:["",Validators.compose([Validators.maxLength(50)])],
      address1zip:["",Validators.compose([Validators.maxLength(30)])],
      address1country:this.address1Country,
      isSameAsAbove: [false],
      address2name:["",Validators.compose([Validators.maxLength(30)])],
      shipToPhone:["",Validators.compose([Validators.maxLength(30)])],
      shipToEmail:["",Validators.compose([Validators.maxLength(30)])],
      address2street:["",Validators.compose([Validators.maxLength(30)])],
      address2city:this.address2City,
      address2state:["",Validators.compose([Validators.maxLength(30)])],
      address2zip:["",Validators.compose([Validators.maxLength(30)])],
      address2country:this.address2Country
	});

    this.getLookupCountries();
  }

  ionViewDidLoad() {
    this.gVLogger.log('ionViewDidLoad CreateCustomerPage');
  }

  createCustomer(){

    // alert(this.customerCreateForm.value.address1country)
  this.validateForm();
    if(this.formValidation()){
      this.formStatus = false;

       var locations = [];
       // let locationShipto = {
       let locationBillto  = {
        id: 0,
        receiverName:this.customerCreateForm.value.address1name,
        phone:this.customerCreateForm.value.billToPhone,
        email:this.customerCreateForm.value.billToEmail,
        addressLine1: this.customerCreateForm.value.address1street,
        addressLine2: "",
        city: this.customerCreateForm.value.address1city,
        state: this.customerCreateForm.value.address1state,
        zipCode: this.customerCreateForm.value.address1zip,
        country: this.customerCreateForm.value.address1country,
        isShipToAddress: 1,
        locationType: "SHIPTO"
    }
    if(this.customerCreateForm.value.isSameAsAbove) {
      locationBillto.locationType = "BILLTOSHIPTO";
      locations.push(locationBillto);
    }else{
      // let locationBillto = {
      let locationShipto = {
        id : 0,
        receiverName:this.customerCreateForm.value.address2name,
        phone:this.customerCreateForm.value.shipToPhone,
        email:this.customerCreateForm.value.shipToEmail,
        addressLine1: this.customerCreateForm.value.address2street,
        addressLine2: "",
        city: this.customerCreateForm.value.address2city,
        state: this.customerCreateForm.value.address2state,
        zipCode: this.customerCreateForm.value.address2zip,
        country: this.customerCreateForm.value.address2country,
        locationType: "BILLTO"
    }

      locations.push(locationShipto);
      locations.push(locationBillto);
    }
    let shippingArray = []

      console.log("lllldolsadsdasddsahfsfdk" +  this.customerCreateForm.value.shippingService)
    if(this.customerCreateForm.value.shippingService !== null && this.customerCreateForm.value.shippingService !== undefined && this.customerCreateForm.value.shippingService !== "na" && this.customerCreateForm.value.shippingService !== ""){
      shippingArray = [{shippingServiceId : parseInt(this.customerCreateForm.value.shippingService),
        shippingServiceValue : this.customerCreateForm.value.accountId }]
    }

    var postJSON = {
      id : 0,
     logedinUser: Number(this.cartManager.getSalesManId()),
     company: this.customerCreateForm.value.company,
     paymentCurrency: this.customerCreateForm.value.paymentCurrency,
     salesPersonCode: this.customerCreateForm.value.iUser,
     name: this.customerCreateForm.value.name,
     contactPerson: this.customerCreateForm.value.contactPerson,
     userName: this.customerCreateForm.value.userName,
     password: this.customerCreateForm.value.password,
     prefixCustomerId: this.customerCreateForm.value.prefix,
     phone: this.customerCreateForm.value.phoneCode + " " + this.customerCreateForm.value.phoneNumber,
     taxGroup: this.customerCreateForm.value.taxGroup,
     customerGroup: this.customerCreateForm.value.customerGroup,
     email: this.customerCreateForm.value.email,
     shippingServiceDTOs : shippingArray,
     locationsDTOs: locations
    }

//     {
//     "name": this.customerCreateForm.value.name,
//     "locationsDTOs": [
//       {
//         "addressLine1": "20 Lucy Ave.",
//         "addressLine2": "",
//         "city": "Toronto",
//         "state": "ON",
//         "zipCode": "M1L1A3",
//         "country": "Canada",
//         "isShipToAddress": 0,
//         "locationType": "BILLTOSHIPTO"
//       }
//     ]
// }

    this.gVLogger.log(postJSON);

let headers = new Headers({
        'Content-Type': 'application/json'
      });
      let options = new RequestOptions({
        headers: headers
      });

    this.formStatus = false;
  this.api.post("customers/add",JSON.stringify(postJSON),options)
  .map(res => res.json())
    .subscribe(data => {
  if(data.status == "200"){
    this.msgManager.toastMsg("Customer Created");
    this.navCtrl.setRoot(SearchCustomersPage).then(()=>{this.navCtrl.push(SearchCustomersPage);});
  }else if(data.status == "401"){ // check for session out
      this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
      this.navCtrl.setRoot(LoginPage);
    }

   });

  this.gVLogger.log(JSON.stringify(postJSON));
    }else{


      // this.presentToast("Please fill all the fields to continue.","bottom");


    }



  }


  getLookupCountries(){

    this.api.get("lookup/codesByTable?tableName=country").map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "200"){
        this.countriesList = result.data;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });

  }


  country1Changed(){

    // this.validateForm();
    //
    // let countryId = this.customerCreateForm.controls.address1country._value;
    // // for (let country of this.countriesList) {
    // //   // code...
    // //   if(country.code == this.customerCreateForm.controls.address1country._value){
    // //     countryId = country.code;
    //
    // //   }
    // // }
    //
    // this.api.get("lookup/codesByCode?codeString=" + countryId).map(res => res.json()).subscribe(result=>{
    //   this.gVLogger.log(result);
    //   if(result.status == "200"){
    //     this.stateList1 = result.data;
    //     this.cityList1 = [];
    //     // this.customerCreateForm.controls['address1state'].setValue("");
    //     this.customerCreateForm.controls['address1city'].setValue("");
    //     this.states1SelectControl = true;
    //     this.cities1SelectControl = false;
    //   }else if(result.status == "401"){ // check for session out
    //       this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
    //       this.navCtrl.setRoot(LoginPage);
    //     }
    // });


  }

  country2Changed(){

    // this.validateForm();
    //
    // let countryId = this.customerCreateForm.controls.address2country._value;
    // // for (let country of this.countriesList) {
    //
    // //   if(country.code == this.customerCreateForm.controls.address2country._value){
    // //     countryId = country.id;
    // //   }
    // // }
    //
    // this.api.get("lookup/codesByCode?codeString=" + countryId).map(res => res.json()).subscribe(result=>{
    //   this.gVLogger.log(result);
    //   if(result.status == "200"){
    //     this.stateList2 = result.data;
    //     this.cityList2 = [];
    //     this.customerCreateForm.controls['address2state'].setValue("");
    //     this.customerCreateForm.controls['address2city'].setValue("");
    //     this.states2SelectControl = true;
    //     this.cities2SelectControl = false;
    //   }else if(result.status == "401"){ // check for session out
    //       this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
    //       this.navCtrl.setRoot(LoginPage);
    //     }
    // });


  }







  state1Changed(){

    this.validateForm();

    this.gVLogger.log("state1 changed");
    let provinceId = this.customerCreateForm.controls.address1state._value;
    // for (let province of this.stateList1) {
    //   // code...
    //   if(province.code == this.customerCreateForm.controls.address1state._value){
    //     provinceId = province.id;

    //   }
    // }

    this.api.get("lookup/codesByCode?codeString=" + provinceId).map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "200"){
        this.cityList1 = result.data;
        this.customerCreateForm.controls['address1city'].setValue("");
        this.cities1SelectControl = true;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });


  }

  state2Changed(){

     this.validateForm();

    let provinceId = this.customerCreateForm.controls.address2state._value;
    // for (let province of this.stateList2) {
    //   // code...
    //   if(province.code == this.customerCreateForm.controls.address2state._value){
    //     provinceId = province.id;
    //   }
    // }

    this.api.get("lookup/codesByCode?codeString=" + provinceId).map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "200"){
        this.cityList2 = result.data;
        this.customerCreateForm.controls['address2city'].setValue("");
        this.cities2SelectControl = true;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });
  }


  checkUsernameUniqeness(){

    this.gVLogger.log(this.customerCreateForm.controls.userName._value +" -- - - ");
   // var body:any = { "query":};

    let body = new FormData();
    body.append('query', this.customerCreateForm.controls.userName._value );

    let headers = new Headers({
        'Content-Type': 'application/json'
      });
      let options = new RequestOptions({
        headers: headers
      });

      this.gVLogger.log(JSON.stringify(body));
    this.api.post('customers/availability',body)
      .map(res => res.json())
        .subscribe(resp => {
          this.gVLogger.log(JSON.stringify(resp));
          if(resp.status=="200"){
            this.formStatus = true;
            this.userNameError = "";
          }else if(resp.status=="500"){
            this.userNameError = this.ERROR_TEXT;
            this.formStatus = false;
            this.msgManager.toastMsg("Username not available please choose other.");
          }else if(resp.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
            this.navCtrl.setRoot(LoginPage);
          }
        });
  }

  loadTaxGroups(){
    this.api.get("lookup/taxGroups").map(res => res.json()).subscribe(result =>{
      if(result.status == "200"){
        this.taxGroupList = result.data;
      }else if(result.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
            this.navCtrl.setRoot(LoginPage);
          }
    });
  }

  loadCustomerGroups(){
    this.api.get("lookup/customerGroups").map(res => res.json()).subscribe(result =>{
      if(result.status == "200"){
        this.customerGroupList = result.data;
      }else if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        this.navCtrl.setRoot(LoginPage);
      }
    });
  }

  loadPaymentTerms(){
  // let body = new FormData();
  // body.append("tableName", "termsCode");

  this.api.get("lookup/codesByTable?tableName=termsCode").map(res => res.json()).subscribe(result =>{
      if(result.status == "200"){
        this.paymentTermsList = result.data;
      }else if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        this.navCtrl.setRoot(LoginPage);
      }
    });
  }

  getCurrenciesList(){
    // let body = new FormData();
    // body.append("tableName", "termsCode");

    this.api.geJazzba("/lookups/search/%20/0/100/currency").map(res => res.json()).subscribe(result =>{
      // if(result.status == "200"){
        this.currenciesList = result.lookups;
      // }else if(result.status == "401"){ // check for session out
      //   this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
      //   this.navCtrl.setRoot(LoginPage);
      // }
    });
  }

  getCountries(){
    this.api.getRA("/api/v1/codes/all/0").subscribe(result=>{
      this.countryCodes=result.json().data;
      console.log("CountryCodes from RA Service", this.countryCodes);
    },err=>{
      console.log("Error", err);
    });
  }

  getProvinces(event){
    // if (event.isUserInput){
    this.customerCreateForm.value.address1state = ""
    let query = " ";
    let offset = 0;
    let resultcount = 100
    this.api.geJazzba("lookups/searchWithOutAdpCustomerId/"+query+"/"+offset+"/"+resultcount+"/Province-"+event)
      .subscribe(data => {
        if(data.status == 401){
          // this.api.tokenExpiredLogout();
        }else{

          this.provinces =  data.json().lookups

          // this.paymentProcessingCode = data.json().lookups;
        }
      },err=>{
        console.log("Error", err);
      });
    // }

  }

  getProvinces2(event){
    // if (event.isUserInput){
    this.customerCreateForm.value.address2state = ""
    let query = " ";
    let offset = 0;
    let resultcount = 100
    this.api.geJazzba("lookups/searchWithOutAdpCustomerId/"+query+"/"+offset+"/"+resultcount+"/Province-"+event)
      .subscribe(data => {
        if(data.status == 401){
          // this.api.tokenExpiredLogout();
        }else{

          this.provinces2 =  data.json().lookups

          // this.paymentProcessingCode = data.json().lookups;
        }
      },err=>{
        console.log("Error", err);
      });
    // }

  }

  getShippingServices(){
    // if (event.isUserInput){
    let query = "%20";
    let offset = 0;
    let resultcount = 100
    this.api.geJazzba("lookups/search/"+query+"/"+offset+"/"+resultcount+"/shippingServices")
      .subscribe(data => {
        if(data.status == 401){
          // this.api.tokenExpiredLogout();
        }else{

          this.shippingServices =  data.json().lookups
          console.log("SSS " + this.shippingServices)

          // this.paymentProcessingCode = data.json().lookups;
        }
      },err=>{
        console.log("Error", err);
      });
    // }

  }

  getProvincesWhileEditing(abbreviation){

    let query = " ";
    let offset = 0;
    let resultcount = 100
    this.api.geJazzba("lookups/searchWithOutAdpCustomerId/"+query+"/"+offset+"/"+resultcount+"/Province-"+abbreviation)
      .subscribe(data => {
        if(data.status == 401){
          // this.api.tokenExpiredLogout();
        }else{
          this.provinces =  data.json().lookups
        }
      },err=>{
        console.log("Error", err);
      });

  }




  nameChanged(){
    this.gVLogger.log("Name field changed")
    if(this.customerCreateForm.controls.name._value == ""){
      this.nameError = this.ERROR_TEXT;
      this.formStatus = false;
    }else{
      this.nameError = "";
      this.validateForm();
    }
  }

  taxGroupChanged(){
    this.gVLogger.log("taxGroup field changed")
    if(this.customerCreateForm.controls.taxGroup._value == "na"){
      this.taxGroupError = this.ERROR_TEXT;
      this.formStatus = false;
    }else{
      this.taxGroupError = "";
      this.validateForm();
    }
  }

   customerGroupChanged(){
     this.gVLogger.log("customer field changed")
    if(this.customerCreateForm.controls.customerGroup._value == ""){
      this.customerGroupError = this.ERROR_TEXT;
      this.formStatus = false;
    }else{
      this.customerGroupError = "";
      this.validateForm();
    }
  }

 city1Changed(){
     this.gVLogger.log("customer field changed")
    if(this.customerCreateForm.controls.address1city._value == "" ||
     this.customerCreateForm.controls.address1city._value == ""){
      this.cityError = this.ERROR_TEXT;
      this.formStatus = false;
    }else{
      this.cityError = "";
      this.validateForm();
    }
  }


  showModalCountry1(){

    this.ss.setItemsList(this.countriesList);
    this.gVLogger.log("countries : " );
    this.gVLogger.log(this.ss.getItemsList());
    this.ss.setVariableType("country1");
    let modal = this.modalController.create(SelectionSearchPage);
    modal.onWillDismiss(data => {
     this.gVLogger.log(data);
     if(data != null){
       if(data.viewType == "country1"){
         this.customerCreateForm.controls.address1country._value = data.item.code;
         this.customerCreateForm.controls['address1country'].setValue(data.item.code);
         this.gVLogger.log("code");
         this.gVLogger.log(data.item.code);
         this.gVLogger.log("code form");
         this.gVLogger.log(this.customerCreateForm.controls.address1country._value);
        this.country1Changed();
       }
     }
   });
    modal.present();
  }


  showModalState1(){
    if(this.states1SelectControl){
        this.ss.setItemsList(this.stateList1);
        //this.gVLogger.log("countries : ",  this.ss.getItemsList());
        this.ss.setVariableType("state1");
        let modal = this.modalController.create(SelectionSearchPage);
        modal.onWillDismiss(data => {
        // this.gVLogger.log("dismiss",data);
         if(data != null){
           if(data.viewType == "state1"){
             this.customerCreateForm.controls.address1state._value = data.item.code;
             this.customerCreateForm.controls['address1state'].setValue(data.item.code);
            // this.gVLogger.log("code",data.item.code);
            // this.gVLogger.log("code form",this.customerCreateForm.controls.address1state._value);
            this.state1Changed();
           }
         }
       });
        modal.present();
      }
    }

    showModalCiy1(){
    if(this.cities1SelectControl){
        this.ss.setItemsList(this.cityList1);
       // this.gVLogger.log("countries : ",  this.ss.getItemsList());
        this.ss.setVariableType("city1");
        let modal = this.modalController.create(SelectionSearchPage);
        modal.onWillDismiss(data => {
        // this.gVLogger.log("dismiss",data);
         if(data != null){
           if(data.viewType == "city1"){
             this.customerCreateForm.controls.address1city._value = data.item.code;
             this.customerCreateForm.controls['address1city'].setValue(data.item.code);
          //   this.gVLogger.log("code",data.item.code);
           //  this.gVLogger.log("code form",this.customerCreateForm.controls.address1city._value);
             this.validateForm();
           // this.state1Changed();
           }
         }
       });
        modal.present();
      }
    }






    showModalCountry2(){

    this.ss.setItemsList(this.countriesList);
   // this.gVLogger.log("countries : ",  this.ss.getItemsList());
    this.ss.setVariableType("country2");
    let modal = this.modalController.create(SelectionSearchPage);
    modal.onWillDismiss(data => {
    // this.gVLogger.log("dismiss",data);
     if(data != null){
       if(data.viewType == "country2"){
         this.customerCreateForm.controls.address2country._value = data.item.code;
         this.customerCreateForm.controls['address2country'].setValue(data.item.code);
        // this.gVLogger.log("code",data.item.code);
        // this.gVLogger.log("code form",this.customerCreateForm.controls.address2country._value);
        this.country2Changed();
       }
     }
   });
    modal.present();
  }


  showModalState2(){
    if(this.states2SelectControl){
        this.ss.setItemsList(this.stateList2);
       // this.gVLogger.log("countries : ",  this.ss.getItemsList());
        this.ss.setVariableType("state2");
        let modal = this.modalController.create(SelectionSearchPage);
        modal.onWillDismiss(data => {
       //  this.gVLogger.log("dismiss",data);
         if(data != null){
           if(data.viewType == "state2"){
             this.customerCreateForm.controls.address2state._value = data.item.code;
             this.customerCreateForm.controls['address2state'].setValue(data.item.code);
           //  this.gVLogger.log("code",data.item.code);
            // this.gVLogger.log("code form",this.customerCreateForm.controls.address2state._value);
            this.state2Changed();
           }
         }
       });
        modal.present();
      }
    }

    showModalCiy2(){
    if(this.cities2SelectControl){
        this.ss.setItemsList(this.cityList2);
       // this.gVLogger.log("countries : ",  this.ss.getItemsList());
        this.ss.setVariableType("city2");
        let modal = this.modalController.create(SelectionSearchPage);
        modal.onWillDismiss(data => {
       //  this.gVLogger.log("dismiss",data);
         if(data != null){
           if(data.viewType == "city2"){
             this.customerCreateForm.controls.address2city._value = data.item.code;
             this.customerCreateForm.controls['address2city'].setValue(data.item.code);
           //  this.gVLogger.log("code",data.item.code);
           //  this.gVLogger.log("code form",this.customerCreateForm.controls.address2city._value);
             this.validateForm();
           // this.state1Changed();
           }
         }
       });
        modal.present();
      }
    }








    validateForm(){
       this.gVLogger.log("validating form");
       this.gVLogger.log("this.customerCreateForm.controls.address1city._value" + this.customerCreateForm.controls.address1city._value);
       this.gVLogger.log("this.customerCreateForm.controls.address1name" + this.customerCreateForm.controls.address1name._value);
       this.gVLogger.log("this.customerCreateForm.controls.address1state._value" + this.customerCreateForm.controls.address1state._value);
       this.gVLogger.log("this.customerCreateForm.controls.email._value" + this.customerCreateForm.controls.email._value);
       this.gVLogger.log("this.customerCreateForm.controls.phoneCode._valu" + this.customerCreateForm.controls.phoneCode._value);
       this.gVLogger.log("this.customerCreateForm.controls.phoneNumber._value" + this.customerCreateForm.controls.phoneNumber._value);
       this.gVLogger.log("this.customerCreateForm.controls.name._value " + this.customerCreateForm.controls.name._value);
      if(
        // this.customerCreateForm.controls.company._value != "na" &&// Payment Terms
        this.customerCreateForm.controls.name._value != ""
        // this.customerCreateForm.controls.paymentCurrency._value != ""// Company Name
        // // this.customerCreateForm.controls.customerGroup._value != "na" &&  // Customer group
        // // this.customerCreateForm.controls.iUser._value != "na" &&
        // // this.customerCreateForm.controls.iUser._value != "" &&
        // this.customerCreateForm.controls.address1city._value != "" &&   // city 1  ////////////////
        // this.customerCreateForm.controls.address1name._value != "" &&   // city 1  ////////////////
        // this.customerCreateForm.controls.address1state._value != "" &&   // city 1  ////////////////
        // // this.customerCreateForm.controls.taxGroup._value != "na" && // taxGroup
        // this.customerCreateForm.controls.email._value != "" && // Email
        // this.customerCreateForm.controls.phoneCode._value != "" &&// Email
        // this.customerCreateForm.controls.phoneNumber._value != "" // Email
        // this.customerCreateForm.controls.prefix._value != "" // Name Prefix
         ){

           // Form is verified
          this.formStatus = true;
        }else{

          this.formStatus = false;
        }

        this.gVLogger.log("Status: ");
        this.gVLogger.log(this.formStatus)

        this.gVLogger.log("Form :");
        this.gVLogger.log(this.customerCreateForm);

    }

    formValidation(){
      if(this.customerCreateForm.value.name === undefined || this.customerCreateForm.value.name === ""){
        this.api.toastMSG("Customer name can't be empty.")
        return false;
      }else if(this.customerCreateForm.value.contactPerson === undefined || this.customerCreateForm.value.contactPerson === ""){
        this.api.toastMSG("Customer contact person can't be empty.")
        return false;
      }else if(this.customerCreateForm.value.paymentCurrency === undefined || this.customerCreateForm.value.paymentCurrency === ""){
        this.api.toastMSG("Customer payment currency can't be empty.")
        return false;
      }else if(this.customerCreateForm.value.email === undefined || this.customerCreateForm.value.email === ""){
        this.api.toastMSG("Customer email can't be empty.")
        return false;
      }else if(this.customerCreateForm.value.phoneCode === undefined || this.customerCreateForm.value.phoneCode === ""){
        this.api.toastMSG("Customer phone can't be empty.")
        return false;
      }else if(this.customerCreateForm.value.address1name === undefined || this.customerCreateForm.value.address1name === ""){
        this.api.toastMSG("Bill to address contact name can't be empty.")
        return false;
      }
      else if(this.customerCreateForm.value.billToEmail === undefined || this.customerCreateForm.value.billToEmail === ""){
        this.api.toastMSG("Bill to address email can't be empty.")
        return false;
      }
      else if(this.customerCreateForm.value.billToPhone === undefined || this.customerCreateForm.value.billToPhone === ""){
        this.api.toastMSG("Bill to address phone can't be empty.")
        return false;
      }else if(this.customerCreateForm.value.address1country === undefined || this.customerCreateForm.value.address1country === ""){
        this.api.toastMSG("Bill to address country can't be empty.")
        return false;
      }else if(this.customerCreateForm.value.address1city === undefined || this.customerCreateForm.value.address1city === ""){
        this.api.toastMSG("Bill to address city can't be empty.")
        return false;
      }else if(this.customerCreateForm.value.address1state === undefined || this.customerCreateForm.value.address1state === ""){
        this.api.toastMSG("Bill to address state can't be empty.")
        return false;
      }else if(this.customerCreateForm.value.address1street === undefined || this.customerCreateForm.value.address1street === ""){
        this.api.toastMSG("Bill to address street can't be empty.")
        return false;
      }else if(this.customerCreateForm.value.address1zip === undefined || this.customerCreateForm.value.address1zip === ""){
        this.api.toastMSG("Bill to address postal code can't be empty.")
        return false;
      }else if(!this.customerCreateForm.value.isSameAsAbove && (this.customerCreateForm.value.address2name === undefined || this.customerCreateForm.value.address2name === "")){
        this.api.toastMSG("Ship to address contact name can't be empty.")
        return false;
      }
      else if(!this.customerCreateForm.value.isSameAsAbove && (this.customerCreateForm.value.shipToEmail === undefined || this.customerCreateForm.value.shipToEmail === "")){
        this.api.toastMSG("Ship to address email can't be empty.")
        return false;
      }
      else if(!this.customerCreateForm.value.isSameAsAbove && (this.customerCreateForm.value.shipToPhone === undefined || this.customerCreateForm.value.shipToPhone === "")){
        this.api.toastMSG("Ship to address phone can't be empty.")
        return false;
      }
      else if(!this.customerCreateForm.value.isSameAsAbove && (this.customerCreateForm.value.address2country === undefined || this.customerCreateForm.value.address2country === "")){
        this.api.toastMSG("Ship to address country can't be empty.")
        return false;
      }else if(!this.customerCreateForm.value.isSameAsAbove && (this.customerCreateForm.value.address2city === undefined || this.customerCreateForm.value.address2city === "")){
        this.api.toastMSG("Ship to address city can't be empty.")
        return false;
      }else if(!this.customerCreateForm.value.isSameAsAbove && (this.customerCreateForm.value.address2state === undefined || this.customerCreateForm.value.address2state === "")){
        this.api.toastMSG("Ship to address state can't be empty.")
        return false;
      }else if(!this.customerCreateForm.value.isSameAsAbove && (this.customerCreateForm.value.address2street === undefined || this.customerCreateForm.value.address2street === "")){
        this.api.toastMSG("Ship to address street can't be empty.")
        return false;
      }else if(!this.customerCreateForm.value.isSameAsAbove && (this.customerCreateForm.value.address2zip === undefined || this.customerCreateForm.value.address2zip === "")){
        this.api.toastMSG("Ship to address postal code can't be empty.")
        return false;
      }else if(this.customerCreateForm.value.shippingService && this.customerCreateForm.value.shippingService !== "na"){
        if(!this.customerCreateForm.value.accountId && (this.customerCreateForm.value.address2zip === undefined || this.customerCreateForm.value.address2zip === "")){
          this.api.toastMSG("Account Id can't be empty.")
          return false;
        }else {
          return true;
        }

      }else {
        return true;
      }
    }



    presentToast(msg,position) {
      let toast = this.toastController.create({
        message: msg,
        duration: 3000,
        position: position
      });
      toast.present();
    }


    getAllIntelliRepUsers(){

      this.api.get("lookup/salesperson/all").map(res => res.json()).subscribe(result =>{
        if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }else if(result.status == "200"){
          this.gVLogger.log("lookup/salesperson/all");
          this.gVLogger.log(result);
          this.intelliRepUsersList = result.data;
        }
      });

    }

  getCountryCodesList(){
    this.api.getRA("/api/v1/codes/all/0").subscribe(result=>{
      this.countryCodes=result.json().data;
      console.log("CountryCodes from RA Service", this.countryCodes);
    });
  }

  setMask(){
    this.mask = ['+',/\d/,' ','(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    // if (localStorage.getItem('countryCode').length == 2) {
    //   this.mask = ['+',/\d/,' ','(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    // } else if (localStorage.getItem('countryCode').length == 3) {
    //   this.mask = ['+',/\d/,/\d/,' ','(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    // } else {
    //   this.mask = ['+',/\d/,' ','(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    // }
    // this.maskLength=this.mask.length;
    // console.log("mask.length",this.mask,this.maskLength)

  }

  checkInput(){
    console.log("III " + this.customerCreateForm.controls.phoneCode._value.length)
    if(this.customerCreateForm.controls.phoneCode._value.length > 17){
      // console.log("dssa " + this.customerCreateForm.controls.phoneCode._value.substring(0,16))
      this.customerCreateForm.controls.phoneCode._value = this.customerCreateForm.controls.phoneCode._value.substring(0,17)
    }
  }

  provinceChanged(event){
    // alert(this.customerCreateForm.controls.address1state)
  }
}



// WEBPACK FOOTER //
// ./src/pages/create-customer/create-customer.ts